import { durationMs, formatDuration, Phase, phaseSaysSomething } from './runDetailModel';

/**
 * Where time went, as one bar in proportion and a legend with the duration of each stretch.
 *
 * The longest stretch is marked in the legend: on a slow run that is the line somebody is looking for.
 */
export const PhaseBar = ({
    phases: all,
    note,
}: {
    phases: Phase[];
    note?: string;
}) => {
    const phases = all.filter(phaseSaysSomething);

    if (phases.length === 0) {
        return null;
    }

    const start = new Date(phases[0].startedAtUtc).getTime();
    const end = Math.max(
        ...phases.map((phase) =>
            phase.finishedAtUtc ? new Date(phase.finishedAtUtc).getTime() : Date.now()
        )
    );
    const total = Math.max(end - start, 1);
    const durations = phases.map((phase) =>
        durationMs(phase.startedAtUtc, phase.finishedAtUtc)
    );
    const longest = durations.indexOf(Math.max(...durations));

    return (
        <div className="rd-phases">
            <div className="rd-phases__bar" role="img" aria-label="Where the time went">
                {phases.map((phase, index) => (
                    <span
                        key={`${phase.id}-${index}`}
                        className={`rd-phases__segment rd-phases__segment--${phase.kind}${
                            phase.finishedAtUtc ? '' : ' rd-phases__segment--going'
                        }`}
                        style={{
                            left: `${((new Date(phase.startedAtUtc).getTime() - start) / total) * 100}%`,
                            width: `${Math.max((durations[index] / total) * 100, 0.6)}%`,
                        }}
                        title={`${phase.title}: ${formatDuration(durations[index])}`}
                    />
                ))}
            </div>
            <ol className="rd-phases__legend">
                {phases.map((phase, index) => (
                    <li
                        key={`${phase.id}-${index}`}
                        className={`rd-phases__item${
                            index === longest && phases.length > 1 ? ' rd-phases__item--longest' : ''
                        }`}
                        title={phase.title}
                    >
                        <span className={`rd-phases__swatch rd-phases__swatch--${phase.kind}`} />
                        <span className="rd-phases__label">{phase.label}</span>
                        <span className="rd-phases__time">
                            {formatDuration(durations[index])}
                            {!phase.finishedAtUtc && '…'}
                        </span>
                    </li>
                ))}
            </ol>
            {note && <p className="rd-phases__note">{note}</p>}
        </div>
    );
};
